import React, { FC, Suspense } from "react";
import { Outlet } from "react-router-dom";
import Head from "./head/Head";
import Header from "./header/Header";
import OfflineOverlay from "../components/network/OfflineOverlay";
import { AccessDeniedHost } from "../rbac/access";

const RouteLoader = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "60vh",
      color: "#8094ae",
      fontSize: 13,
    }}
  >
    Loading…
  </div>
);

interface LayoutProps {
  title?: string;
  [key: string]: any;
}

const Layout: FC<LayoutProps> = ({ title, ...props }) => {
  return (
    <>
      <Head title={title || "ProcureX BIM"} />
      <OfflineOverlay />
      <AccessDeniedHost />
      <div className="nk-app-root">
        <div className="nk-wrap">
          <Header fixed />
          <Suspense fallback={<RouteLoader />}>
            <Outlet />
          </Suspense>
          <div className="nk-footer">
            <div className="container-fluid">
              <div className="nk-footer-wrap">
                <div className="nk-footer-copyright">
                  &copy; 2026 ProcureX BIM. All Rights Reserved.
                </div>
                <div className="nk-footer-links">
                  <ul className="nav nav-sm">
                    <li className="nav-item"><a className="nav-link" href="#">Terms</a></li>
                    <li className="nav-item"><a className="nav-link" href="#">Privacy</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
